<script setup lang="ts">
import DatePickerField from '@/components/Fields/DatePickerField.vue'
import { StackLayout } from '@/components/Layouts'
import type { AdvancedDetectionFilters } from '@/types/filters/DetectionFilters'
import moment from 'moment'

type Props = {
    filters: Partial<AdvancedDetectionFilters>
}
defineProps<Props>()
type Emits = {
    (e: 'change', value: Partial<AdvancedDetectionFilters>): void
}
defineEmits<Emits>()
</script>

<template>
    <StackLayout :gap="8" class="full-width advanced-datepicker">
        <DatePickerField
            :label="$t('detection.filters.startDate')"
            :modelValue="filters.start_at ? moment(filters.start_at).toDate() : undefined"
            @change="
                $emit('change', {
                    start_at: $event
                        ? moment(
                              moment($event).startOf('d').format(moment.defaultFormatUtc)
                          ).toDate()
                        : undefined
                })
            "
            :maxDate="
                filters.end_at
                    ? moment(filters.end_at).startOf('d').toDate()
                    : moment().startOf('d').toDate()
            "
            clearable
            class="full-width" />
        <DatePickerField
            :label="$t('detection.filters.endDate')"
            :modelValue="filters.end_at ? moment(filters.end_at).toDate() : undefined"
            @change="
                $emit('change', {
                    end_at: $event
                        ? moment(moment($event).endOf('d').format(moment.defaultFormatUtc)).toDate()
                        : undefined
                })
            "
            :maxDate="moment().endOf('d').toDate()"
            clearable
            class="full-width" />
    </StackLayout>
</template>

<style scoped lang="scss">
.advanced-datepicker {
    & :deep(.dropdown-content) {
        @media screen and (min-width: 1024px) {
            position: fixed;
        }
    }
    & :deep(.dropdown-menu) {
        @media screen and (max-width: 1023px) {
            margin-top: 7vh;
            display: flex;
            flex-direction: column;
            justify-content: center;
            max-height: unset;
        }
    }
}
</style>
